import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { WallDisplayConfiguration } from '../models';

export const MapWallDisplayActions = createActionGroup({
  source: 'Map Wall Display',
  events: {
    'Show Map Wall Display': props<{ stringifiedWallConfiguration: string }>(),
    'Hide Map Wall Display': emptyProps(),
    'Edit Map Wall Display': props<{ stringifiedWallConfiguration: string }>(),
    'Set Configuration': props<{ configuration: WallDisplayConfiguration }>(),
    'Update Configuration': props<{ configuration: WallDisplayConfiguration }>(),
    'Show Times Widget Config': emptyProps(),
    'Show Locations Widget Config': emptyProps(),
    'Show Image Widget Config': emptyProps(),
    'Show Alerts Feed Widget Config': emptyProps(),
    'Hide Widget Config': emptyProps()
  }
});
